import { createApp } from "vue";
import { createPinia } from "pinia";
import { createHead } from "@vueuse/head";
import App from "./App.vue";
import router from "./router";
import { reveal } from "./directives/reveal";
import "./style.css";

const app = createApp(App);
const pinia = createPinia();
const head = createHead();

app.use(router);
app.use(pinia);
app.use(head);
app.directive("reveal", reveal);
app.mount("#app");
